//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherPrivilegesAndSettingsInputItem } from './TeacherPrivilegesAndSettingsInputItem';

export class TestTeacherInputItem extends ItemBase {
    FirstName: string | null = null;
    LastName: string | null = null;
    PrivilegesAndSettings: TeacherPrivilegesAndSettingsInputItem | null = null;
    EnableOldAttendance: boolean = false;
    EmailAddress: string | null = null;
    TelephoneNumber: string | null = null;
    Address: string | null = null;
    Note: string | null = null;
    ZoomMeetingURL: string | null = null;
    BiographyBody: string | null = null;

    constructor(initializer?: Partial<TestTeacherInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestTeacherInputItem";
}
